module.exports = __webpack_public_path__ + "static/img/right-top-row-2.38c0e24e.png";